export function datePicker() {
    $(".date-picker").datepicker({
        dateFormat: "dd/mm/yy"
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/date-picker.js